export const mainnavPradaschier = async (err) => {
  if (err) {
    console.error(err);
  }

  /*
   * Show submenu on click
   */
  const mainMenuLinks = document.querySelectorAll(
      '#blog-5 .nav-primary .nav > .menu-item-has-children > a',
    ),
    submenuBackLinkPradaschier = document.querySelector(
      '#blog-5 #sub-menu-back-link-pradaschier',
    );
  submenuClickHandler(mainMenuLinks);

  /*   const mainMenuLinksSubmenu = document.querySelectorAll(
    '#blog-5 .nav-primary .nav > .menu-item > a + .sub-menu > li > a',
  );

  submenuClickHandler(mainMenuLinksSubmenu); */

  // Show submenu if current page is a submenu item on page load
  // Open navigation only if in mobile viewport

  const currentMenuItem = document.querySelector(
    '#blog-5 .nav-primary .current-menu-item',
  );

  const currentMenuParent = document.querySelector(
    '#blog-5 .nav-primary .current-menu-parent',
  );

  window.addEventListener(
    'resize',
    function () {
      if (window.innerWidth < 1199) {
        if (currentMenuItem) {
          currentMenuItem.parentElement.classList.add('visible');

          // show submenu back link
          if (submenuBackLinkPradaschier) {
            submenuBackLinkPradaschier.style.visibility = 'visible';
          }

          currentMenuParent.parentElement.classList.add('visible');

          /*     document
            .getElementsByTagName('html')[0]
            .classList.add('submenu-open'); */
          currentMenuItem.parentElement.previousElementSibling.classList.add(
            'submenu--open',
          );
        }
      } else {
        if (currentMenuItem) {
          currentMenuItem.parentElement.classList.remove('visible');

          // show submenu back link
          if (submenuBackLinkPradaschier) {
            submenuBackLinkPradaschier.style.visibility = 'hidden';
          }

          currentMenuParent.parentElement.classList.remove('visible');

          /*         document.getElementsByTagName('html')[0].classList.add('submenu-open');
    currentMenuItem.parentElement.previousElementSibling.classList.add(
      'submenu--open',
    ); */
        }
      }
    },
    true,
  );

  function submenuClickHandler(mainMenuLinks) {
    mainMenuLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        const submenu = link.nextElementSibling;

        if (submenu && submenu.classList.contains('visible')) {
          // If submenu is already visible, hide it
          submenu.classList.remove('visible');
          link.classList.remove('submenu--open');
          document
            .getElementsByTagName('html')[0]
            .classList.remove('submenu-open');
        } else {
          submenu.classList.add('visible');
          // If submenu is not visible, show it
          link.classList.add('submenu--open');
          document
            .getElementsByTagName('html')[0]
            .classList.add('submenu-open');
        }

        mainMenuLinks.forEach((otherLink) => {
          if (otherLink !== link) {
            // Remove active state color from all links if it's not ticket link
            if (!otherLink.parentElement.classList.contains('menu-item-261')) {
              otherLink.style.color = '#3c3c3c';
            }

            link.style.color = '#C60219';

            const otherSubmenu = otherLink.nextElementSibling;
            if (otherSubmenu) {
              otherSubmenu.classList.remove('visible');
              otherSubmenu.previousElementSibling.classList.remove(
                'submenu--open',
              );
            }
          }
        });

        if (!submenu.classList.contains('sub-menu')) {
          // If no submenu, just follow the link
          window.location.href = link.href;
        }
        // If Weglot language switcher clicked, not toggling submenu
        if (link.parentElement.classList.contains('weglot-lang')) {
          document
            .getElementsByTagName('html')[0]
            .classList.remove('submenu-open');
        }
      });
    });

    // If clicked on weglot language switcher, do not toggle submenu
  }
  /*
   * close submenu on close link click
   */
  const closeSubmenu = document.querySelector('.close-submenu');

  if (closeSubmenu) {
    closeSubmenu.addEventListener('click', (e) => {
      e.preventDefault();
      const visibleSubmenus = document.querySelectorAll('.sub-menu.visible');
      visibleSubmenus.forEach((submenu) => {
        submenu.classList.remove('visible');
      });

      document.getElementsByTagName('html')[0].classList.remove('submenu-open');
      document
        .getElementsByClassName('submenu--open')[0]
        .classList.remove('submenu--open');

      // remove inline css from main menu links
      mainMenuLinks.forEach((link) => {
        link.removeAttribute('style');
      });
    });
  }

  /*
   * Submenu backlink on mobile
   */
  if (submenuBackLinkPradaschier) {
    if (document.getElementsByClassName('submenu--open')[0]) {
      submenuBackLinkPradaschier.style.visibility = 'visible';
    }
    submenuBackLinkPradaschier.addEventListener('click', (e) => {
      e.preventDefault();

      if (document.getElementsByClassName('submenu--open')[0]) {
        document
          .getElementsByClassName('submenu--open')[0]
          .classList.remove('submenu--open');
      }

      if (document.getElementsByClassName('visible')[0]) {
        document
          .getElementsByClassName('visible')[0]
          .classList.remove('visible');
        submenuBackLinkPradaschier.style.visibility = 'hidden';
      }
    });
  }

  /*
   * Show submenu if current menu item is a submenu on click on mainmenu item
   */

  // check if menu-toggle is clicked
  const menuToggle = document.querySelector('.menu-toggle');
  if (menuToggle) {
    menuToggle.addEventListener('click', () => {
      // check if current-menu-ancestor is present

      // add class nav-open to html tag
      /*       if (htmlTag.classList.contains('nav-open')) {
        htmlTag.classList.remove('nav-open');
      } */

      const htmlTag = document.getElementsByTagName('html')[0];

      if (htmlTag.querySelector('.current-menu-ancestor')) {
        const submenu = htmlTag.querySelector(
          '.current-menu-ancestor .sub-menu',
        );
        if (submenu) {
          submenu.classList.add('visible');
          htmlTag.classList.add('submenu-open');

          //htmlTag.classList.add('nav-open');
          // show back link
          /*           const submenuBackLinkPradaschier =
            document.getElementsByClassName('sub-menu-back-link')[0];
          if (submenuBackLinkPradaschier) {
            submenuBackLinkPradaschier.style.visibility = 'visible';
          } */
        }
      }
    });

    /*
     * Change color of current menu ancestor item on menu click
     */
  }
};

import.meta.webpackHot?.accept(mainnavPradaschier);
